export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const HR_AUTH_START = 'HR_AUTH_START';


export const LOGO_CHECK = 'LOGO_CHECK';